import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CalendarSharingPermissionsModalRenderer from './CalendarSharingPermissionsModalRenderer';
import ColoredBulletOption from './ColoredBulletOption';
import getStore from '../data/store/store';
import strings from 'owa-strings/owa-options-strings';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { observer } from 'mobx-react';
import { showCalendarSharingPermissionsDialog } from 'owa-calendar-sharing/lib/actions/calendarSharing';
import 'owa-calendar-sharing/lib/orchestrators/loadCalendarSharePermissionsOrchestrator';
var styles = require('./ShareACalendarSection.scss');
var CALENDAR_SHARING_TIME_DELAY = 0;
/**
 * Dropdown index set to -1 so that dropdown selection does not change
 * The dropdown is an entry point for calendar sharing dialog and not used for selecting any property value.
 */
var SELECTED_CALENDAR_INDEX = -1;
/**
 * This renders the dropdown entry point for Calendar sharing dialog box
 */
export default observer(function ShareACalendarSection() {
    var calendars = getStore().calendars;
    return (React.createElement("div", { className: styles.shareACalendarWrapper },
        React.createElement("div", { className: styles.shareACalendarSectionMessage }, strings.options_sharedCalendars_ShareCalendarSectionMessage),
        React.createElement(Dropdown, { className: styles.dropdownContainer, placeHolder: strings.options_sharedCalendars_SelectCalendarLabel, selectedKey: SELECTED_CALENDAR_INDEX, calloutProps: {
                className: styles.shareACalendarCallout,
            }, onRenderOption: onRenderOption, onChanged: function (item) {
                var calendar = calendars[item.key];
                // Added setTimeout with zero delay to avoid the JS error for maximum call stack exceeded
                // when two modal box get displayed on top of each other while dropdown closes.
                setTimeout(function () {
                    return show(calendar.folderId, '', calendar.hexColorString, calendar.calendarName);
                }, CALENDAR_SHARING_TIME_DELAY);
            }, options: getCalendarOptions(calendars) })));
});
var containerDiv = null;
/**
 * Function to render the Calendar sharing permission modal wrapper
 */
function show(folderId, calendarId, calendarColor, calendarName) {
    showCalendarSharingPermissionsDialog(folderId, calendarId, calendarColor, calendarName);
    close(); // close if it is already showing
    containerDiv = document.createElement('div');
    containerDiv.id = 'calendarSharingDialog';
    document.body.appendChild(containerDiv);
    ReactDOM.render(React.createElement(CalendarSharingPermissionsModalRenderer, null), containerDiv);
}
/**
 *  Function to remove the calendar sharing modal renderer from DOM
 */
function close() {
    if (containerDiv) {
        ReactDOM.unmountComponentAtNode(containerDiv);
        document.body.removeChild(containerDiv);
        containerDiv = null;
    }
}
var getCalendarOptions = function (calendars) {
    var calendarsToShare = calendars.map(function (sharedCalendar, index) {
        return {
            key: index,
            text: sharedCalendar.calendarName,
            canShare: sharedCalendar.canShare,
            data: {
                color: sharedCalendar.hexColorString,
            },
        };
    });
    return calendarsToShare.filter(function (calendar) {
        return calendar.canShare;
    });
};
/**
 * Custom renderer for dropdown as a colored bullet needs to be shown
 */
var onRenderOption = function (option) {
    return React.createElement(ColoredBulletOption, { color: option.data.color, label: option.text });
};
//# sourceMappingURL=ShareACalendarSection.js.map